export default "__VITE_ASSET__CRttVcfw__"